import React, { useEffect } from 'react';
import { router } from "@inertiajs/react";
import TopContent from "@/User/Pages/Top/Components/TopContent";
import Features from "@/User/Pages/Top/Components/Features";
import SmallCta from "@/User/Pages/Top/Components/SmallCta";
import NewSearch from "@/User/Pages/Top/Components/NewSearch";
import ConditionTagSearch from "@/User/Pages/Top/Components/ConditionTagSearch";
import AppAppeal from "@/User/Pages/Top/Components/AppAppeal";
import ConditionSearch from "@/User/Pages/Top/Components/ConditionSearch";
import SEO from '@/User/Components/SEO';
import NewArticles from './Components/NewArticles';

const TopPage = () => {
    useEffect(() => {
        // Retrieve relatives data after loading page lazy
        const timer = setTimeout(() => {
            router.reload({
                only: [
                    'prefectureList',
                    'industryCodeList',
                    'budgetList',
                    'themeList',
                    'filteredIndustryIds',
                    'filteredBudgetList',
                    'filteredThemeList',
                    'industryCategoryList',
                    'articleList',
                    'jobOfferList',
                ],
            });
        }, 0);

        return () => clearTimeout(timer);
    }, []);

    return (
        <>
            <SEO title="独立・起業ならリラパス｜独立を目指す人のためのスカウトサービス"
                description="リラパスは、ご経歴や「低資金」「未経験」など希望からあなたに合ったフランチャイズや独立案件の招待が直接届きます。スマートで漏れのないビジネスのチャンスをあなたに。" />
            <TopContent />
            <Features />
            <SmallCta />
            <NewSearch />
            <ConditionSearch />
            <ConditionTagSearch />
            <SmallCta />
            <NewArticles />
            <AppAppeal />
        </>
    );
};

export default TopPage;
